import { render, staticRenderFns } from "./CreateRationCopyModal.vue?vue&type=template&id=52d1b139&lang=pug&"
import script from "./CreateRationCopyModal.vue?vue&type=script&lang=js&"
export * from "./CreateRationCopyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports